import axios from "axios";
import {baseAddress} from "../../../tools/baseAddress";

let addressGetAdminList = baseAddress + "api/admin/list";
let addressAddAdmin = baseAddress + "api/admin/add";
let addressDeleteAdmin = baseAddress + "api/admin/delete";
export const getAdminList = () => {
  return axios
    .post(addressGetAdminList, {
      token: localStorage.getItem("token")
    })
    .then(response => {
      return response
    })
    .catch(err => {
      console.error(err)
    })
}

export const addAdmin = (email) => {
  return axios
    .post(addressAddAdmin, {
      token: localStorage.getItem("token"),
      email: email
    })
    .then(response => {
      return response
    })
    .catch(err => {
      return err.response
    })
}


export const deleteAdmin = (email) => {
  return axios
    .post(addressDeleteAdmin, {
      token: localStorage.getItem("token"),
      email: email
    })
    .then(response => {
      return response
    })
    .catch(err => {
      return err.response
    })
}
